import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { LOGO_FALLBACK } from "@/lib/api";

export default function AdminLogin() {
  const { login, user, loading } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Bienvenida, Maria.");
      nav("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Credenciales incorrectas.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 bg-[color:var(--gcs-ivory)]" data-testid="admin-login">
      {/* Left visual */}
      <div className="hidden md:block relative bg-[color:var(--gcs-emerald)] with-grain overflow-hidden">
        <div className="absolute inset-0 flex flex-col justify-between p-12 text-[color:var(--gcs-ivory)] z-10">
          <div className="flex items-center gap-3">
            <img src={LOGO_FALLBACK} alt="Logo" className="h-12 w-12 object-contain rounded-sm bg-[color:var(--gcs-ivory)] p-1" />
            <div>
              <div className="font-serif text-lg">General Cleaning Services, LLC</div>
              <div className="overline text-[color:var(--gcs-gold)]">Panel admin</div>
            </div>
          </div>
          <div>
            <h1 className="font-serif text-5xl md:text-6xl leading-[1.02]">
              Un espacio para <em className="text-[color:var(--gcs-gold)]">curar</em> tu marca.
            </h1>
            <p className="mt-4 text-[color:var(--gcs-ivory)]/70 max-w-md">
              Edita imágenes, precios, testimonios y contacto en tiempo real.
            </p>
          </div>
        </div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-8 md:p-16">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="admin-login-form">
          <p className="overline text-[color:var(--gcs-gold)] mb-4">Acceso admin</p>
          <h2 className="font-serif text-4xl md:text-5xl text-[color:var(--gcs-emerald)] mb-8">Iniciar sesión</h2>

          <label className="block mb-6">
            <span className="overline text-[color:var(--gcs-emerald)]/70">Email</span>
            <input
              type="email"
              className="input-editorial mt-2"
              placeholder="maria.solis.gcs@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email-input"
            />
          </label>
          <label className="block mb-8">
            <span className="overline text-[color:var(--gcs-emerald)]/70">Contraseña</span>
            <input
              type="password"
              className="input-editorial mt-2"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password-input"
            />
          </label>

          <button
            type="submit"
            disabled={busy}
            className="w-full rounded-full btn-emerald px-6 py-3.5 text-sm font-semibold disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {busy ? "Entrando…" : "Entrar al panel"}
          </button>

          <a href="/" className="mt-6 inline-block overline text-[color:var(--gcs-gold)] gcs-underline" data-testid="admin-back-home">
            ← Volver al sitio
          </a>
        </form>
      </div>
    </div>
  );
}
